import React, { Component } from "react";
import TruncateText from "../generic/TruncateText";
import PropTypes from "prop-types";

import TrackedAnchor from "../generic/TrackedAnchor";

import "./eResourceItem.less";
import EresourceEventTypes from "data/types/EresourceEventTypes";

class EResourceItem extends Component {

	render() {
		return (
		<TrackedAnchor
			anchorClass="eresource-item"
			href={this.props.url}
			target={"_blank"}
			featureType={EresourceEventTypes.ERESOURCES_NAME_CLICKED}
			destId={this.props.destId}
			srcId={this.props.srcId}
		>
				<div className="eresource-img-container">
						<img alt={this.props.displayText} src={this.props.imageUrl} title={this.props.displayText} />

				</div>
				<div className="eresource-name">
						<TruncateText
							line={1}
							truncateText="..."
							text={this.props.displayText}
						/>
				</div >
			</TrackedAnchor>
		);
	}
}

EResourceItem.propTypes = {
	imageUrl: PropTypes.string,
	displayText: PropTypes.string.isRequired,
	destId: PropTypes.string,
	featureType: PropTypes.object
};

export default EResourceItem;



// WEBPACK FOOTER //
// ./src/react/views/eResources/EResourceItem.jsx